import { inr, signed, tone, fmt, istDateTime } from "../../lib/format";
import { Panel, Metric, th, td, Empty } from "../Panel";

export function TradebookReport({ rows }) {
  if (!rows.length) return <Panel><Empty testid="tradebook-empty">No trades in this range.</Empty></Panel>;
  const H = ["Time", "Symbol", "Exchange", "Side", "Product", "Qty", "Price", "Value", "Charges"];
  return (
    <Panel title={`Tradebook · ${rows.length} trades`}>
      <div className="overflow-auto thin-scroll max-h-[560px]">
        <table className="w-full" data-testid="tradebook-table">
          <thead className="border-b border-border sticky top-0 bg-card"><tr>{H.map((h, i) => <th key={h} className={`${th} ${i > 4 ? "text-right" : ""}`}>{h}</th>)}</tr></thead>
          <tbody>{rows.map((t) => (
            <tr key={t.id} className="border-b border-border/60 hover:bg-accent/40" data-testid={`tradebook-row-${t.id}`}>
              <td className={`${td} num text-muted-foreground`}>{istDateTime(t.at)}</td>
              <td className={`${td} font-medium`}>{t.symbol}</td>
              <td className={`${td} text-muted-foreground`}>{t.exchange}</td>
              <td className={`${td} font-semibold ${t.side === "BUY" ? "text-up" : "text-down"}`}>{t.side}</td>
              <td className={td}>{t.product}</td>
              <td className={`${td} num text-right`}>{t.qty}</td>
              <td className={`${td} num text-right`}>{fmt(t.price)}</td>
              <td className={`${td} num text-right`}>{fmt(t.qty * t.price)}</td>
              <td className={`${td} num text-right text-muted-foreground`}>{fmt(t.charges?.total)}</td>
            </tr>))}</tbody>
        </table>
      </div>
    </Panel>
  );
}

export function LedgerReport({ data, filtered }) {
  const s = data.summary;
  return (
    <div className="space-y-4" data-testid="ledger-report">
      <Panel>
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-border">
          <Metric label="Opening balance" sub={filtered ? "all entry types" : null} value={inr(s.opening_balance)} testid="ledger-opening" />
          <Metric label={filtered ? "Credits (filtered)" : "Credits"} value={<span className="text-up">{inr(s.credits)}</span>} testid="ledger-credits" />
          <Metric label={filtered ? "Debits (filtered)" : "Debits"} value={<span className="text-down">{inr(Math.abs(s.debits))}</span>} testid="ledger-debits" />
          <Metric label="Closing balance" sub={filtered ? "all entry types" : null} value={inr(s.closing_balance)} testid="ledger-closing" />
        </div>
      </Panel>
      <Panel title={`Ledger · ${s.entries} entries`}>
        {!data.rows.length ? <Empty testid="ledger-report-empty">No ledger entries in this range.</Empty> : (
          <div className="overflow-auto thin-scroll max-h-[520px]">
            <table className="w-full" data-testid="ledger-report-table">
              <thead className="border-b border-border sticky top-0 bg-card"><tr>{["Time", "Type", "Description", "Amount", "Balance"].map((h, i) => <th key={h} className={`${th} ${i > 2 ? "text-right" : ""}`}>{h}</th>)}</tr></thead>
              <tbody>{data.rows.map((e) => (
                <tr key={e.id} className="border-b border-border/60">
                  <td className={`${td} num text-muted-foreground`}>{istDateTime(e.at)}</td>
                  <td className={`${td} text-[10.5px] font-semibold tracking-wide`}>{e.type.replace(/_/g, " ")}</td>
                  <td className={`${td} max-w-[380px] truncate`} title={e.note}>{e.note}</td>
                  <td className={`${td} num text-right ${tone(e.amount)}`}>{signed(e.amount)}</td>
                  <td className={`${td} num text-right`}>{fmt(e.balance_after)}</td>
                </tr>))}</tbody>
            </table>
          </div>)}
      </Panel>
    </div>
  );
}
